import styled from 'styled-components';

const HEADER_HEIGHT = 64;

export const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.white};
  overflow: hidden;
  max-width: 400px;
  margin: 0 auto;
  opacity: 0;
  animation: fadeInStep 0.3s ease-in-out forwards;

  @keyframes fadeInStep {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const LayoutHeader = styled.header`
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  min-height: ${HEADER_HEIGHT}px;
  background-color: inherit;
  padding: 16px;
  box-sizing: border-box;
  position: sticky;
  top: 0;
  z-index: 10;
`;

export const BackButton = styled.button`
  all: unset;
  color: ${({ theme }) => theme.colors.blackShades(0.87)};
  font-size: 24px;
  height: 24px;
  width: 24px;
  outline: none;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  flex-shrink: 0;

  &:hover {
    opacity: 0.7;
  }
`;

export const HeaderTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.highBlack};
  margin: 0;
  text-align: center;
  flex: 1;
`;

export const HeaderSpacer = styled.div`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
`;

export const ContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  padding: 24px 0;
  padding-top: ${({ hasHeader }) => (hasHeader ? '0' : '24px')};
  padding-bottom: ${({ hasFooter }) => (hasFooter ? '0' : '24px')};
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  gap: 16px;
`;

export const Footer = styled.footer`
  flex-shrink: 0;
  width: 100%;
  max-width: 400px;
  background-color: ${({ theme }) => theme.colors.white};
  padding: 16px;
  box-sizing: border-box;
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
`;
